<div class="h-screen flex flex-col bg-slate-50">
  <header class="w-full bg-primary shadow-sm">
    <div class="flex items-center justify-between px-4 py-3 sm:px-6">
      <div class="flex items-center gap-3">
        @if (authenticated$ | async) {
          <button
            pButton
            type="button"
            class="p-button-text p-0 md:hidden"
            (click)="toggleSidebar()"
            aria-label="Open menu"
          >
            <i class="pi pi-bars text-2xl text-white"></i>
          </button>
        }
      </div>

      <div class="flex-1 flex justify-center">
        <a routerLink="/dashboard" class="relative inline-block">
          <img src="/logo.png" alt="logo" class="object-contain max-h-[54px] -my-[10px]" />
          @if (isTest) {
            <span
              class="absolute bottom-5 -left-4 z-10 transform rotate-45 origin-bottom-left bg-red-600 text-white font-bold text-xs px-3 py-0.5 shadow-sm rounded-md pointer-events-none"
            >
              Test
            </span>
          }
        </a>
      </div>

      <div class="flex items-center gap-3">
        @if (authenticated$ | async) {
          <p-avatar
            icon="pi pi-user"
            shape="circle"
            size="normal"
            class="bg-white! cursor-pointer"
            (click)="menu.toggle($event)"
          ></p-avatar>
        }
      </div>
    </div>
    <p-menu #menu [popup]="true" [model]="(menuItems$ | async)!" appendTo="body" styleClass="custom-menu"> </p-menu>
  </header>

  <m4w-breadcrumb></m4w-breadcrumb>

  <div class="flex-1 flex overflow-hidden">
    <main class="flex-1 overflow-auto p-4 pt-2">
      <router-outlet></router-outlet>
    </main>
  </div>

  <p-drawer
    [visible]="sidebarVisible()"
    position="left"
    (visibleChange)="sidebarVisible.set($event)"
    [baseZIndex]="10000"
    blockScroll="true"
  >
    <ng-template #header>
      <h3 class="text-lg font-semibold">Management4Water</h3>
    </ng-template>

    <div>
      <ul class="list-none m-0">
        @for (module of modules; track $index) {
          <li class="border-b border-slate-200 last:border-b-0">
            <div
              pRipple
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="animate-slidedown"
              leaveToClass="hidden"
              leaveActiveClass="animate-slideup"
              class="p-4 cursor-pointer p-ripple"
            >
              <a
                [routerLink]="module.routerLink"
                class="flex items-center justify-between"
                (click)="module.routerLink ? sidebarVisible.set(false) : null"
              >
                <div class="flex items-center">
                  @if (module.icon) {
                    <i class="pi {{ module.icon }} mr-2"></i>
                  }
                  <span class="font-medium">{{ module.name }}</span>
                </div>
                @if (module.sections.length > 0) {
                  <i class="pi pi-chevron-down"></i>
                }
              </a>
            </div>
            <ul class="list-none p-0 m-0 ml-2 overflow-hidden hidden">
              @for (section of module.sections; track $index) {
                <li *m4wRolePermission="section.requiredRoles">
                  <a
                    pRipple
                    [routerLink]="section.routerLink"
                    class="flex items-center cursor-pointer p-4 rounded-border duration-150 transition-colors p-ripple"
                    (click)="sidebarVisible.set(false)"
                  >
                    <i class="pi {{ section.icon }} mr-2"></i>
                    <span class="font-medium">{{ section.name }}</span>
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>

    <ng-template #footer>
      <div class="border-t border-slate-200 mt-4 pt-3 px-4">
        <p class="text-sm mb-1">Made internationally with love ❤️</p>
        <p class="text-xs text-slate-500">Release name: {{ version.releaseName }}</p>
        <p class="text-xs text-slate-500">Version number: {{ version.versionNumber }}</p>
      </div>
    </ng-template>
  </p-drawer>
</div>
